import React, { Component } from "react";
import FilterForm from "./FilterForm";
import EstudiantesTable from "./EstudiantesTable";
import ComisionSummary from "./ComisionSummary";
import { calculateComision, calculateCostoAdmin, calculateTotalPrecios } from "./calculations";
import { toast } from "react-toastify";
import { Col, Row, Button, Spinner } from "reactstrap";
import Papa from 'papaparse';
import axios from "axios";
import { API_URL_partidas_curso_abierto } from "../../../constants";

import { getAuthHeaders } from "../../../utils/auth";
class CursoAbiertoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            searchQuery: "",
            filterNombre: "",
            filterPartner: "",
            filterVendedor: "",
            totalPrecioByVendedor: {},
            totalPrecioAllVendedores: 0,
            totalComisionByVendedor: {},
            totalComisionAllVendedores: 0,
            totalComisionByVendedorAndMoneda: {},
            adminCostPercentage: 0.1,
            isUploading: false,
        };
    }

    componentDidMount() {
        this.calculateTotals();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.estudiantes_curso_abierto !== this.props.estudiantes_curso_abierto) {
            this.calculateTotals();
        }
    }

    calculateTotals = () => {
        this.calculateTotalPrecios();
        this.calculateComision();
        this.calculateCostoAdmin();
    };

    handleAdminCostChange = (event) => {
        const newAdminCostPercentage = parseFloat(event.target.value) || 0;
        this.setState({ adminCostPercentage: newAdminCostPercentage }, this.calculateTotals);
    };

    calculateComision = () => {
        const { estudiantes_curso_abierto } = this.props;
        const { totalComisionByVendedor, totalComisionAllVendedores } = calculateComision(estudiantes_curso_abierto);
        this.setState({ totalComisionByVendedor, totalComisionAllVendedores });
    };

    calculateCostoAdmin = () => {
        const { estudiantes_curso_abierto } = this.props;
        const { adminCostPercentage } = this.state;
        const { totalCostoAdminPorPartner, totalCostoAdmin } = calculateCostoAdmin(estudiantes_curso_abierto, adminCostPercentage);
        this.setState({ totalCostoAdminPorPartner, totalCostoAdmin });
    };

    calculateTotalPrecios = () => {
        const { estudiantes_curso_abierto } = this.props;
        const { totalPrecioByVendedor, totalPrecioAllVendedores } = calculateTotalPrecios(estudiantes_curso_abierto);
        this.setState({ totalPrecioByVendedor, totalPrecioAllVendedores });
    };

    handleFilterChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    filterEstudiantes = (estudiantes) => {
        const { filterNombre, filterPartner, filterVendedor } = this.state;
        return estudiantes.filter(estudiante => (
            estudiante.nombre?.toLowerCase().includes(filterNombre.toLowerCase()) &&
            estudiante.partner_vendedor?.toLowerCase().includes(filterPartner.toLowerCase()) &&
            estudiante.miembro_vendedor?.toLowerCase().includes(filterVendedor.toLowerCase())
        ));
    };

    formatCurrency = (value) => {
        return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    calculateTotalPrecioFiltered = (filteredEstudiantes) => {
        return filteredEstudiantes.reduce((acc, estudiante) => acc + (estudiante.precio || 0), 0);
    };

    // Properly escape CSV values to handle commas, quotes, and newlines
    escapeCSVValue = (value) => {
        if (value == null) return '';
        const stringValue = String(value);
        // If value contains semicolon, quote, or newline, wrap in quotes and escape quotes
        if (stringValue.includes(';') || stringValue.includes('"') || stringValue.includes('\n')) {
            return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
    };

    downloadCSV = () => {
        const { estudiantes_curso_abierto } = this.props;
        
        // Use semicolon as delimiter (better for Excel in many locales)
        const csvHeader = "Proyecto Code;Nombre;Miembro Vendedor;Partner Vendedor;Comision Vendedor;Correo;Telefono;Precio;Moneda;Referencia;Observaciones";

        const csvRows = estudiantes_curso_abierto.map(estudiante =>
          [
            this.escapeCSVValue(estudiante.proyecto_code),
            this.escapeCSVValue(estudiante.nombre),
            this.escapeCSVValue(estudiante.miembro_vendedor),
            this.escapeCSVValue(estudiante.partner_vendedor),
            this.escapeCSVValue(estudiante.comision_vendedor),
            this.escapeCSVValue(estudiante.correo),
            this.escapeCSVValue(estudiante.telefono),
            this.escapeCSVValue(estudiante.precio),
            this.escapeCSVValue(estudiante.moneda),
            this.escapeCSVValue(estudiante.referencia),
            this.escapeCSVValue(estudiante.observaciones),
          ].join(';')  // Changed to semicolon
        );
    
        const csvData = [csvHeader, ...csvRows].join('\r\n');  // Windows line endings
        
        // Add UTF-8 BOM - this is CRITICAL for Excel to recognize UTF-8
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
    
        const today = new Date();
        const dateStr = today.toISOString().slice(0, 10);
    
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Estudiantes_${dateStr}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        toast.success("✅ CSV descargado con codificación UTF-8");
        console.log('💾 CSV downloaded with UTF-8 encoding and BOM');
    }
    
    handleFileUpload = () => {
      const { file } = this.state;
      if (!file) {
          toast.warning('Por favor selecciona un archivo');
          return;
      }
    
      console.log('📁 File selected:', file.name, 'Type:', file.type);
      this.setState({ isUploading: true });
    
      // Let PapaParse handle the file directly with proper encoding
      Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          encoding: "UTF-8",
          complete: this.updateDatabase,
          error: (error) => {
              console.error('❌ Error parsing file:', error);
              toast.error("Error al procesar el archivo. Por favor intenta de nuevo.");
              this.setState({ isUploading: false, file: null });
          }
      });
    };
    
    
    updateDatabase = async (result) => {
        console.log('📊 Raw CSV parsing result:', result);
        console.log('📝 First row raw data:', result.data[0]);
        
        const normalized = result.data.map(row => {
            const cleaned = {};
            Object.keys(row).forEach(key => {
                if (!key) return;
                const newKey = key.trim();
                cleaned[newKey] = row[key];
            });
            return cleaned;
        });

        console.log('🧹 Normalized data (first row):', normalized[0]);

        const col = (row, ...keys) => {
            for (const k of keys) {
                if (row[k] !== undefined && row[k] !== "") return row[k];
            }
            return "";
        };

        const data = normalized
            .filter(row => col(row, "Nombre", "Nombre Completo", "nombre"))
            .map(row => ({
                nombre: col(row, "Nombre", "Nombre Completo", "nombre").trim(),
                miembro_vendedor: col(row, "Miembro Vendedor", "miembro_vendedor").trim(),
                partner_vendedor: col(row, "Partner Vendedor", "partner_vendedor").trim(),
                comision_vendedor: parseFloat(col(row, "Comision Vendedor", "comision_vendedor") || "0"),
                correo: col(row, "Correo", "Email", "email", "correo").trim(),
                telefono: col(row, "Telefono", "Teléfono", "telefono").trim(),
                precio: parseFloat(col(row, "Precio", "precio") || "0"),
                moneda: (col(row, "Moneda", "moneda") || "USD").trim(),
                referencia: col(row, "Referencia", "referencia").trim() || null,
                observaciones: col(row, "Observaciones", "observaciones").trim() || null,
                grupo: (col(row, "grupo", "Grupo") || "Default Value").trim(),
                proyecto_code: this.props.proyectoCodeSelected || 'Default Value',
            }));

        console.log('🎯 Final data to send (first entry):', data[0]);
        console.log('🔤 Nombre encoding test:', data[0]?.nombre, 'Length:', data[0]?.nombre?.length);
        
        // Check for encoding issues
        if (data[0]?.nombre) {
            const hasIssue = /[�]/.test(data[0].nombre);
            console.log('⚠️ Has encoding issue (� character):', hasIssue);
        }

        if (data.length === 0) {
            toast.warning("No se encontraron datos válidos en el archivo");
            this.setState({ isUploading: false, file: null });
            return;
        }

        const headers = getAuthHeaders();
        
        console.log('📤 Sending to API with headers:', headers);
        
        try {
            // Make all API calls in parallel for better performance
            const promises = data.map(entry => 
                axios.post(API_URL_partidas_curso_abierto, entry, { headers })
                    .then(() => ({ success: true, entry }))
                    .catch(error => ({ success: false, entry, error }))
            );

            const results = await Promise.all(promises);
            
            // Count successes and failures
            const successes = results.filter(r => r.success).length;
            const failures = results.filter(r => !r.success);

            console.log('✅ Successes:', successes, '❌ Failures:', failures.length);

            if (failures.length === 0) {
                toast.success(`${successes} estudiante(s) subido(s) exitosamente`);
            } else if (successes > 0) {
                toast.warning(`${successes} estudiante(s) subido(s), ${failures.length} fallaron`);
                console.error('Failed entries:', failures);
            } else {
                toast.error(`Error al subir estudiantes. Por favor intenta de nuevo.`);
                console.error('All entries failed:', failures);
            }

            // Reload data if any successes
            if (successes > 0 && this.props.resetState) {
                this.props.resetState();
            }

            // Clear the file from state
            this.setState({ file: null, isUploading: false });

        } catch (error) {
            toast.error("Error al actualizar la base de datos. Por favor intenta de nuevo.");
            console.error('❌ Error updating database:', error);
            
            if (error.response && error.response.data) {
                console.error('Error details:', error.response.data);
            }
            
            this.setState({ isUploading: false, file: null });
        }
    };
    
    
    handleFileChange = (event) => {
      this.setState({ file: event.target.files[0] });
    };

    render() {
        const { estudiantes_curso_abierto } = this.props;
        const {
            totalComisionAllVendedores,
            totalComisionByVendedor,
            filterNombre,
            filterPartner,
            filterVendedor,
            isUploading,
        } = this.state;

        const filteredEstudiantes = estudiantes_curso_abierto ? this.filterEstudiantes(estudiantes_curso_abierto) : [];
        const sortedEstudiantes = filteredEstudiantes.slice().sort((a, b) => a.nombre.localeCompare(b.nombre));
        const totalPrecioFiltered = this.calculateTotalPrecioFiltered(filteredEstudiantes);
        const totalEstudiantesFiltered = filteredEstudiantes.length;

        return (
            <div>
                <br></br>
                <Row>
                    <Col>
                        <Button 
                            style={{ backgroundColor: '#ADD8E6', color: 'black' }} 
                            onClick={this.downloadCSV}
                            disabled={isUploading}
                        >
                            Descarga Estudiantes a CSV
                        </Button>
                    </Col>
                    <Col>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input 
                                type="file" 
                                accept=".csv" 
                                onChange={this.handleFileChange}
                                disabled={isUploading}
                            />
                            <Button 
                                onClick={this.handleFileUpload}
                                disabled={isUploading}
                                color="primary"
                            >
                                {isUploading ? (
                                    <>
                                        <Spinner size="sm" /> Subiendo...
                                    </>
                                ) : (
                                    'Upload CSV'
                                )}
                            </Button>
                        </div>
                    </Col>  
                </Row>
                <br></br>
                <FilterForm
                    filterNombre={filterNombre}
                    filterPartner={filterPartner}
                    filterVendedor={filterVendedor}
                    handleFilterChange={this.handleFilterChange}
                />
                <div style={{ marginTop: "20px" }}>
                    <h4>Total comision de vendedores: {this.formatCurrency(totalComisionAllVendedores)}</h4>
                </div>
                <div style={{ marginTop: "20px" }}>
                    <h4>Total precio filtrado: {this.formatCurrency(totalPrecioFiltered)}</h4>
                    <h4>Total estudiantes filtrados: {totalEstudiantesFiltered}</h4>
                </div>
                <EstudiantesTable
                    estudiantes={sortedEstudiantes}
                    formatCurrency={this.formatCurrency}
                    resetState={this.props.resetState}
                    proyectoMoneda={this.props.proyectoMoneda}
                />
                <ComisionSummary
                    totalComisionByVendedor={totalComisionByVendedor}
                    formatCurrency={this.formatCurrency}
                />
            </div>
        );
    }
}

export default CursoAbiertoList;